export const taxType = {
  GST: 'GST',
  VAT: 'VAT'
}

export const currencyCode = {
  INR: 'INR',
  GBP: 'GBP'
}

export const currencySymbol = {
  INR: '₹',
  GBP: '£'
}

export const countryCode = {
  India: 'IN',
  UnitedKingdom: 'GB'
}

export const country = {
  India: 'India',
  UnitedKingdom: 'United Kingdom'
}

export const mobilePortalDomain = (() => {
  switch(process.env.VUE_APP_RELEASE_STAGE)
  {
    case 'production':
      return 'app.bizgain.in';
    case 'testing':
      return 'testbizgain.mediabuy.pro';
    case 'development':
      return 'roimatic.adbox.pro';
    default:
      return 'app.bizgain.in'
  }
})()

